/***************************************************************************************************
** getIconProps
***************************************************************************************************/

import cn from "@utils/cn";

export default function getIconProps(icon, otherProps = {}) {
  const { fallback, ...passthroughProps } = otherProps;

  const fallbackProps = fallback ? { iconName: fallback, ...passthroughProps } : null;

  if (!icon || icon === "resource://null") {
    return fallbackProps;
  }

  if (typeof icon === "string" || Array.isArray(icon)) {
    return {
      iconName: icon,
      ...passthroughProps,
    };
  }

  const { name, ...iconProps } = icon;

  if (!name || name === "resource://null") {
    return fallbackProps;
  }

  const className = cn(iconProps.className, passthroughProps.className);

  return {
    iconName: name,
    ...iconProps,
    ...passthroughProps,
    className: className,
  };
}
